import ViewHeadlineIcon from "@mui/icons-material/ViewHeadline";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import csiCard from "csi/card/_base";
import { Box, FlexRowCenter, ToggleButton, ToggleButtonGroup } from "designSystem/index";
import Text from "designSystem/components/text/Text";
import { isGalleryViewDisabledFor, useDataSetupStore } from "csi/state/datasetup";
import { useStore } from "csi/state/hooks";
import { action } from "mobx";
import { observer } from "mobx-react-lite";
import React, { Fragment } from "react";

export const DataSetupItem = observer(() => {
	const { localStore } = useStore();
	const dataSetupStore = useDataSetupStore();
	const { activeItem } = dataSetupStore;
	const { description, id, name, nodeType, viewId } = activeItem;
	const TABLE = "1";
	const GALLERY = "2";

	const onChangeViewMode = action((event: object, value: string) => {
		// set view mode for current item if value has changed (non-null)
		if (value !== null) {
			localStore.dataSetup.setViewItemAsGallery(id, (value === GALLERY));
		}
	});

	/** determines if the gallery view should be enabled based on whether or not the node type has images or a main image */
	const enableGalleryView = !!csiCard.getAttributeCardImageKey(nodeType) && !isGalleryViewDisabledFor(viewId);

	return (
		<Fragment>
			<FlexRowCenter flexShrink={0} height={26}>
				<Box flexGrow={1}>
					<Text
						bold
						color="textPrimary"
						size={16}
						text={name}
					/>
				</Box>
				{enableGalleryView && (
					<FlexRowCenter>
						<ToggleButtonGroup
							aria-label="view mode"
							exclusive
							onChange={onChangeViewMode}
							value={localStore.dataSetup.viewItemAsGallery(id) ? GALLERY : TABLE}
						>
							<ToggleButton
								aria-label="table"
								tooltipProps={{ res: "ListView" }}
								value={TABLE}
							>
								<ViewHeadlineIcon />
							</ToggleButton>
							<ToggleButton
								aria-label="gallery"
								tooltipProps={{ res: "GalleryView" }}
								value={GALLERY}
							>
								<ViewModuleIcon />
							</ToggleButton>
						</ToggleButtonGroup>
					</FlexRowCenter>
				)}
			</FlexRowCenter>
			{description && (
				<Box flexShrink={0} mt={4}>
					{description}
				</Box>
			)}
		</Fragment>
	);
});

export default DataSetupItem;
